import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import tryParseInt from '../utils.common/tryParseInt';
import { PlusIcon } from '../ecardsPreact.icons/PlusIcon';
import { MinusIcon } from '../ecardsPreact.icons/MinusIcon';
import { Steps } from '../ecardsPreact.constants/steps';
import { useField } from 'formik';
import eCardRecipient from '../ecardsPreact.classes/eCardRecipient';

export default function ECardAddRecipientsManual(props) {
    const { currentStep, hidden, recipientsCount, maxRecipients } = props;

    const minCount = 1;
    const maxCount = maxRecipients - recipientsCount;

    const [count, setCount] = useState(1);
    const [rerender, setRerender] = useState(false); // used to forcing setCount hook on blur
    const [recipientsField, meta, helpers] = useField('EcardMessageDetails.Recipients');

    const prevStepRef = useRef();
    const prevStep = prevStepRef.current;

    const increment = () => setCount((count) => count + 1);
    const decrement = () => setCount((count) => count - 1);

    const handleInputBlur = (e) => {
        setCount((count) => tryParseInt(e.target.value, count));
        setRerender(!rerender);
    };

    const handleOnChange = (e) => {
        setCount((count) => tryParseInt(e.target.value, count));
    };

    useEffect(() => {
        if (count < minCount) {
            setCount(minCount);
        } else if (count > maxCount) {
            setCount(maxCount);
        }
    }, [count, rerender]);

    useEffect(
        (e) => {
            if (prevStep === Steps.AddRecipientsManual && currentStep === Steps.Personalise) {
                let newRecipients = [];

                for (let i = 0; i < count; i += 1) {
                    newRecipients.push(new eCardRecipient());
                }

                helpers.setValue(recipientsField.value.concat(newRecipients));

                setCount(1);
            }

            prevStepRef.current = currentStep;
        },
        [currentStep]
    );

    return (
        <section class="ecard-form__section ecard-form__section--selector ecard-form__section--padded" hidden={hidden} aria-labelledby="recipients-manual">
            <header class="ecard-form__header">
                <h1 class="text-h3 text-blue" id="recipients-manual">
                    How many more recipients would you like to send to?
                </h1>
            </header>

            <div class="quantity-selector">
                <button class="quantity-selector__button" type="button" disabled={count <= minCount} onClick={decrement}>
                    <MinusIcon class="quantity-selector__icon" />
                    <span class="sr-only">Reduce</span>
                </button>
                <div class="quantity-selector__input-wrapper">
                    <label class="sr-only" for="recipientsToAdd">
                        Recipients to add
                    </label>
                    <input
                        class="quantity-selector__input"
                        type="number"
                        min={minCount}
                        max={maxCount}
                        name="recipientsToAdd"
                        id="recipientsToAdd"
                        value={count}
                        onBlur={handleInputBlur}
                        onChange={handleOnChange}
                    />
                </div>
                <button class="quantity-selector__button" type="button" disabled={count >= maxCount} onClick={increment}>
                    <PlusIcon class="quantity-selector__icon" />
                    <span class="sr-only">Add</span>
                </button>
            </div>
        </section>
    );
}
